import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: BASE });

// Pick localized value from {fr, en} objects
export const loc = (field, lang) => {
  if (field && typeof field === "object") {
    return lang?.startsWith("en") ? field.en : field.fr;
  }
  return field;
};

export const formatMUR = (price, lang) =>
  `Rs ${price.toLocaleString(lang?.startsWith("en") ? "en-GB" : "fr-FR")}`;

export const formatDate = (iso, lang) =>
  new Date(iso).toLocaleDateString(lang?.startsWith("en") ? "en-GB" : "fr-FR", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
